import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { LoginService } from './login.service';

@Injectable()
export class NotificationService {

  private URL: string = environment.urlbase;

  private allReadSubject: Subject<void> = new Subject<void>();
  /** Emite quando todas as notificações são marcadas como lidas com sucesso. */
  readonly allRead$: Observable<void> = this.allReadSubject.asObservable();

  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  markAllAsRead(): Observable<unknown> {
    const headers: HttpHeaders = this.loginService.getHeaders();
    return this.http.post<unknown>(`${this.URL}notifications/allread`, {}, { headers })
      .pipe(tap((): void => this.allReadSubject.next()));
  }
}
